import { cleanFormDataByConfig } from '@/components/transactions-page/generateSignaturePacket-page';
import { IRenderTemplateField, IRenderTemplatePage } from '@/components/transactions-page/generateSignaturePacket-page/templateComponents/types';
import { getUTCDate } from '@/shared/utils/date';
import _ from 'lodash';

const removeEmptyValuesFromFormData = (formData: any): any => {
  const cleanedData = _.transform(
    formData,
    (result: any, value, key) => {
      if (_.isArray(value)) {
        const nestedCleanedArray = value.filter((item) => !_.isEmpty(item));
        if (nestedCleanedArray.length > 0) {
          result[key] = nestedCleanedArray;
        }
      } else if (_.isObject(value)) {
        const nestedCleanedData = removeEmptyValuesFromFormData(value);
        if (!_.isEmpty(nestedCleanedData)) {
          result[key] = nestedCleanedData;
        }
      } else if (!_.isNil(value) && value !== '') {
        result[key] = value;
      }
    },
    {}
  );

  return cleanedData;
};

export const getTemplateWithFormData = (pages: IRenderTemplatePage[], legalEntityDocumentationData: { [key: string]: any }) => {
  const cleanedDataByConfig = cleanFormDataByConfig(pages, legalEntityDocumentationData, false);

  return pages.map((page) => {
    const cleanedFormData = removeEmptyValuesFromFormData(cleanedDataByConfig[page.name] || {});
    const formData = legalEntityDocumentationData[page.name] || {};

    if (Object.keys(cleanedFormData).length) {
      return { ...page, formData, showZeroState: !cleanedFormData };
    }
    return { ...page, formData, showZeroState: page.name !== 'addAnAttachmentFile' };
  });
};

export const getCustomComponentValue = (field: IRenderTemplateField, formData: any): string => {
  if (!Object.keys(formData).length) return '';
  const matchingField = Object.keys(formData).find((key) => key === field.name);

  switch (field.component) {
    case 'date':
      return matchingField ? getUTCDate(formData[matchingField]) : '';
    case 'phoneNumber':
      if (!Object.keys(formData[matchingField] || {}).length) return '';

      const code = Object.values(formData[matchingField])[0] as string;
      const number = Object.values(formData[matchingField])[1] as string;
      return matchingField ? `(+${code}) ${number}` : '';
    case 'checkbox':
      return matchingField ? field?.config?.optionLabel ?? '' : '';
    case 'radio':
      return matchingField ? field?.config?.items.find((item: any) => item.value === formData[matchingField])?.label ?? '' : '';
    default:
      return matchingField ? formData[matchingField] : '';
  }
};
